import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Card, Flex } from "@mantine/core";
import { AppDrawer } from "./AppDrawer";
import { KeyboardArrowRightOutlined } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
import { useState } from "react";
export const DrawerIf = ({ children, drawerBreakpoint, cardTitle = "Click to expand", cardStyle, drawerTitle, drawerContentStyle }) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsx(Flex, { flex: 1, visibleFrom: drawerBreakpoint, children: children }), _jsx(Card, { hiddenFrom: drawerBreakpoint, style: {
                    padding: "1rem",
                    cursor: "pointer",
                    boxShadow: "0 0 10px color-mix(in srgb, var(--mantine-color-black) 10%, transparent)",
                    ...cardStyle
                }, onClick: () => setIsDrawerOpen(true), children: _jsxs(Flex, { align: "center", justify: "space-between", children: [cardTitle, _jsx(SvgIcon, { component: KeyboardArrowRightOutlined })] }) }), _jsx(AppDrawer, { variant: "drawer-if", title: drawerTitle, position: "right", size: "xl", hiddenFrom: drawerBreakpoint, opened: isDrawerOpen, onClose: () => setIsDrawerOpen(false), children: _jsx("div", { style: {
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        ...drawerContentStyle
                    }, children: children }) })] }));
};
